import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { Link as LinkIcon } from "@mui/icons-material";
import RagDocumentUploadDialog from "./RagDocumentUploadDialog";

export const LinkDocumentMenu = ({
  parentDocument,
  allowedChildTypes,
  onUploadSuccess,
  disabled = false,
  openDialogs = {},
  setOpenDialogs,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (sourceType) => {
    handleMenuClose();
    if (setOpenDialogs) {
      setOpenDialogs({
        ...openDialogs,
        [sourceType]: true,
      });
    }
  };

  const formatSourceType = (type) => {
    return type
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleDialogClose = (sourceType) => {
    if (setOpenDialogs) {
      setOpenDialogs({
        ...openDialogs,
        [sourceType]: false,
      });
    }
  };

  const handleUploadSuccess = (sourceType) => {
    handleDialogClose(sourceType);
    onUploadSuccess?.();
  };

  if (!allowedChildTypes || allowedChildTypes.length === 0) {
    return null;
  }

  const tooltipTitle = disabled
    ? "Cannot link documents to failed uploads"
    : "Upload a linked document";

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <span>
          <IconButton
            size="small"
            onClick={handleMenuOpen}
            disabled={disabled}
            sx={{ color: "primary.main" }}
            data-testid="link-document-button"
          >
            <LinkIcon />
          </IconButton>
        </span>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {allowedChildTypes.map((childType) => (
          <MenuItem
            key={childType}
            onClick={() => handleMenuItemClick(childType)}
          >
            Upload linked {formatSourceType(childType)}
          </MenuItem>
        ))}
      </Menu>

      {allowedChildTypes.map((childType) => (
        <RagDocumentUploadDialog
          key={childType}
          open={openDialogs[childType] || false}
          onClose={() => handleDialogClose(childType)}
          onUploadSuccess={() => handleUploadSuccess(childType)}
          parentDocument={parentDocument}
          preselectedSourceType={childType}
        />
      ))}
    </>
  );
};

export default LinkDocumentMenu;
